/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable object-curly-newline */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-bitwise */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, {
  useCallback, useContext, useEffect, useMemo, useState,
} from 'react';
import { useLocation, useHistory, Link } from 'react-router-dom';
import moment from 'moment-timezone';
import {
  Search, ChevronsUpDown, ChevronUp, ChevronDown, ChevronLeft, ChevronRight,
} from 'lucide-react';
import CircularProgress from '@mui/material/CircularProgress';
import { sendRequest } from '../../api/shootAPI';
import API from '../../api/endpoints';
import { UserContext } from '../../contexts/User';
import './timesheets.css';
import ExportAllModal from './ExportAllModal';
import { Navbar, Sidebar } from '../../components';
import useDebounce from '../../hooks/useDebounce';
import { formatActivityPercentage } from '../../utils/activity';
import { formatSeconds } from '../../utils/time';
import DateRangePicker from '../../components/dateRangePicker';
import TimezoneDropdown from '../../components/selectors/TimezoneDropdown';
import { STYLED_SELECT_CLASS, STYLED_SELECT_STYLE } from '../../utils/styledSelect';

const AVATAR_PALETTE = [
  { bg: '#fdebe6', fg: '#b94f3c' },
  { bg: '#fde6d2', fg: '#F19235' },
  { bg: '#eef5ea', fg: '#53A551' },
  { bg: '#e8eef7', fg: '#4062E5' },
  { bg: '#f5e6f7', fg: '#9333ea' },
];

function avatarColors(key) {
  const str = String(key || '');
  let h = 0;
  for (let i = 0; i < str.length; i += 1) h = (h * 31 + str.charCodeAt(i)) >>> 0;
  return AVATAR_PALETTE[h % AVATAR_PALETTE.length];
}

function initialsFrom(firstName, lastName, email) {
  if (firstName && lastName) return `${firstName[0]}${lastName[0]}`.toUpperCase();
  if (email) return email.slice(0, 2).toUpperCase();
  return '?';
}

function activityColor(value) {
  const v = Number.isFinite(value) ? value : 0;
  if (v >= 70) return '#53A551';
  if (v >= 40) return '#F19235';
  return '#b94f3c';
}

function SortIcon({ active, dir }) {
  if (!active) return <ChevronsUpDown size={12} className="text-ink-500" />;
  return dir === 'asc' ? <ChevronUp size={12} /> : <ChevronDown size={12} />;
}

function InlinePagination({
  page, pageSize, total, onPageChange, onPageSizeChange,
}) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const start = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const end = Math.min(total, page * pageSize);
  const pages = useMemo(() => {
    const max = 5;
    if (totalPages <= max) return Array.from({ length: totalPages }, (_, i) => i + 1);
    const half = Math.floor(max / 2);
    let from = Math.max(1, page - half);
    let to = from + max - 1;
    if (to > totalPages) {
      to = totalPages;
      from = totalPages - max + 1;
    }
    return Array.from({ length: max }, (_, i) => from + i);
  }, [page, totalPages]);

  return (
    <div
      className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 px-5 py-3"
      style={{ borderTop: '1px solid #f1f2f5' }}
    >
      <div className="flex items-center gap-1 flex-wrap">
        <button
          type="button"
          onClick={() => onPageChange(Math.max(1, page - 1))}
          disabled={page === 1}
          aria-label="Previous page"
          className="w-8 h-8 inline-flex items-center justify-center rounded-[6px] text-ink-900 hover:bg-surface-1 disabled:opacity-40 disabled:cursor-not-allowed transition"
        >
          <ChevronLeft size={16} />
        </button>
        {pages.map((p) => {
          const active = p === page;
          return (
            <button
              key={p}
              type="button"
              onClick={() => onPageChange(p)}
              className={`min-w-[32px] h-8 px-2 inline-flex items-center justify-center rounded-[6px] text-sm font-medium transition ${
                active ? 'bg-brand-700 text-white' : 'text-ink-900 hover:bg-surface-1'
              }`}
            >
              {p}
            </button>
          );
        })}
        <button
          type="button"
          onClick={() => onPageChange(Math.min(totalPages, page + 1))}
          disabled={page === totalPages || total === 0}
          aria-label="Next page"
          className="w-8 h-8 inline-flex items-center justify-center rounded-[6px] text-ink-900 hover:bg-surface-1 disabled:opacity-40 disabled:cursor-not-allowed transition"
        >
          <ChevronRight size={16} />
        </button>
      </div>
      <div className="flex items-center gap-3 text-sm text-ink-900 flex-wrap">
        <span>Rows Per Page:</span>
        <select
          value={pageSize}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
          className="px-2 py-1 rounded-[6px] text-sm bg-white text-ink-900 focus:outline-none focus:border-brand-500"
          style={{ border: '1px solid #e0e1e6' }}
        >
          <option value={10}>10</option>
          <option value={25}>25</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
        </select>
        <span className="text-ink-500">|</span>
        <span className="tabular-nums">
          {start}
          -
          {end}
          {' '}
          of
          {' '}
          {total}
        </span>
      </div>
    </div>
  );
}

function Timesheets() {
  const { search } = useLocation();
  const history = useHistory();
  const query = new URLSearchParams(search);
  const pageParam = query.get('page');
  const { activeWorkspace, user } = useContext(UserContext);

  const [rows, setRows] = useState([]);
  const [totals, setTotals] = useState({ totalSeconds: 0, activityLabel: '--' });
  const [currentPage, setCurrentPage] = useState(pageParam ? parseInt(pageParam, 10) : 1);
  const [pageSize, setPageSize] = useState(10);
  const [, setTotalPages] = useState(1);
  const [totalCounts, setTotalCounts] = useState(0);
  const [showExportAllModal, setShowExportAllModal] = useState(false);
  const [searchInput, setSearchInput] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { debounce } = useDebounce();
  const [sortKey, setSortKey] = useState('name');
  const [sortDir, setSortDir] = useState('asc');
  const [teams, setTeams] = useState([]);
  const [selectedTeamId, setSelectedTeamId] = useState(0);
  const [selectedTimezone, setSelectedTimezone] = useState(activeWorkspace.timezone);
  const [date, setDate] = useState(() => {
    const initialToday = moment.tz(selectedTimezone).toDate();
    return [initialToday, initialToday];
  });

  useEffect(() => {
    const initialToday = moment.tz(selectedTimezone).startOf('day').toDate();
    setDate([initialToday, initialToday]);
  }, [selectedTimezone]);

  const fetchActivity = async (timezone = null) => {
    const [startDate, endDate] = date;
    const tz = timezone || selectedTimezone;
    const startOfDay = moment.tz(startDate, tz).startOf('day').clone().utc()
      .format('YYYY-MM-DD HH:mm:ss');
    const endOfDay = moment.tz(endDate, tz).endOf('day').clone().utc()
      .format('YYYY-MM-DD HH:mm:ss');

    const baseParams = {
      start: startOfDay,
      end: endOfDay,
      page: currentPage,
      name: searchQuery,
      teamId: selectedTeamId,
      sortKey,
      sortOrder: sortDir,
      pageSize,
      timezone: tz,
    };

    setIsLoading(true);
    const response = await sendRequest({
      method: 'get',
      url: API.WORKSPACE.membersActivity(activeWorkspace.id),
      timeout: 60000,
      params: baseParams,
    });
    if (response.success) {
      const { mappedOffTime, totalOffTime } = response.data.offTimeRequests?.reduce(
        (acc, entry) => {
          const seconds = Number(entry.totalHours || 0) * 60;
          const { memberId, date: entryDate } = entry;
          const entryMoment = moment(entryDate);
          if (
            entryMoment.isSameOrAfter(moment(startDate), 'day')
            && entryMoment.isSameOrBefore(moment(endDate), 'day')
          ) {
            if (!acc.mappedOffTime[memberId]) acc.mappedOffTime[memberId] = 0;
            acc.mappedOffTime[memberId] += seconds;
            acc.totalOffTime += seconds;
          }
          return acc;
        },
        { mappedOffTime: {}, totalOffTime: 0 },
      ) || { mappedOffTime: {}, totalOffTime: 0 };

      const { mappedManualTimeEntries, totalManualTime } = response.data.manualEntries?.reduce(
        (acc, entry) => {
          const seconds = Number(entry.secondsElapsed) || 0;
          acc.mappedManualTimeEntries[entry.memberId] = seconds;
          acc.totalManualTime += seconds;
          return acc;
        },
        { mappedManualTimeEntries: {}, totalManualTime: 0 },
      ) || { mappedManualTimeEntries: {}, totalManualTime: 0 };

      const mappedRows = (response.data?.members || []).map((member) => {
        const { activityPercentage, secondsElapsed } = member;
        const manualTimeEntrySeconds = mappedManualTimeEntries[member.id] || 0;
        const ptoSeconds = mappedOffTime[member.id] || 0;
        const totalSeconds = (secondsElapsed ?? 0) + manualTimeEntrySeconds + ptoSeconds;
        const pct = activityPercentage ? Math.round(parseFloat(activityPercentage * 100)) : null;
        return {
          id: member.id,
          firstName: member.haveJoined ? member?.user?.firstName : '',
          lastName: member.haveJoined ? member?.user?.lastName : '',
          email: member?.user?.email,
          member,
          totalSeconds,
          activityPercent: pct,
        };
      });

      const totalActivityPct = formatActivityPercentage(
        response.data?.totalActiveSeconds,
        response.data?.totalSecondsElapsed,
      );
      setTotals({
        totalSeconds: (response.data?.totalSecondsElapsed ?? 0) + totalManualTime + totalOffTime,
        activityLabel: `${totalActivityPct ?? '--'}%`,
      });
      setRows(mappedRows);
      setTotalPages(response.data?.pageInfo.totalPages ?? 1);
      setTotalCounts(response.data?.pageInfo.totalCounts ?? 0);
    }
    setIsLoading(false);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSetSearch = useCallback(debounce((q) => {
    setSearchQuery(q);
    setCurrentPage(1);
  }, 500), []);

  const handleSearchChange = (e) => {
    setSearchInput(e.target.value);
    debouncedSetSearch(e.target.value);
  };

  const handlePageChange = (next) => {
    setCurrentPage(next);
    history.push(`?page=${next}`);
  };

  const handlePageSizeChange = (size) => {
    setCurrentPage(1);
    setPageSize(size);
  };

  useEffect(() => {
    fetchActivity();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, searchQuery, pageSize, date, selectedTeamId, sortKey, sortDir]);

  const getTeams = async () => {
    const response = await sendRequest({
      method: 'get',
      url: API.WORKSPACE.getAllTeamInfo(activeWorkspace.id),
      timeout: 60000,
    });
    if (response.success) setTeams(response.data.teams);
  };

  useEffect(() => {
    getTeams();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSelectTimezone = async (timezone) => {
    setSelectedTimezone(timezone);
    await fetchActivity(timezone);
  };

  const toggleSort = (key) => {
    if (key === sortKey) {
      setSortDir((d) => (d === 'asc' ? 'desc' : 'asc'));
    } else {
      setSortKey(key);
      setSortDir('asc');
    }
  };

  return (
    <div>
      {showExportAllModal && (
        <ExportAllModal
          teams={teams}
          selectedTimezone={selectedTimezone}
          selectedTeamId={selectedTeamId}
          setSelectedTeamId={setSelectedTeamId}
          closeModal={() => setShowExportAllModal(false)}
        />
      )}
      <Navbar />
      <Sidebar />
      <div className="screen-wrapper">
        <div className="screen-header" style={{ fontFamily: 'Inter, sans-serif' }}>
          <div className="flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between">
            <div className="min-w-0 flex-1">
              <h1
                className="font-bold text-ink-900 leading-tight truncate text-2xl lg:text-[32px] lg:leading-10"
                data-testid="title"
                data-tour="timesheets"
                style={{ fontFamily: 'Inter, sans-serif' }}
              >
                Timesheets
              </h1>
              <p
                className="text-sm text-ink-500 mt-1"
                data-testid="subtitle"
              >
                View time spent working and activity
              </p>
            </div>
            <button
              type="button"
              onClick={() => setShowExportAllModal(true)}
              data-testid="export-all-btn"
              className="inline-flex items-center gap-1.5 px-4 py-2 rounded-[8px] text-xs font-semibold uppercase tracking-wider text-[#53A551] bg-white hover:bg-[#eef5ea] transition whitespace-nowrap flex-shrink-0"
              style={{ border: '1px solid #53A551' }}
            >
              Export All
            </button>
          </div>

          {/* Filters row */}
          <div className="flex flex-col lg:flex-row lg:items-center gap-3 mt-4 mb-5">
            <div className="w-full lg:w-auto">
              <DateRangePicker
                value={date}
                onChange={(_date) => setDate(_date)}
                className="w-auto"
                placement="bottomStart"
              />
            </div>
            <div className="relative flex-1 min-w-[200px]" style={{ height: '40px' }}>
              <Search
                size={14}
                className="text-ink-500 pointer-events-none"
                style={{
                  position: 'absolute',
                  left: '12px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  zIndex: 1,
                }}
              />
              <input
                type="text"
                value={searchInput}
                onChange={handleSearchChange}
                placeholder="Search for user"
                data-testid="search"
                className="w-full rounded-[8px] bg-white text-ink-900 placeholder:text-ink-500 border border-rule focus:outline-none focus:border-brand-500"
                style={{
                  height: '40px',
                  paddingLeft: '36px',
                  paddingRight: '12px',
                  fontSize: '14px',
                  lineHeight: '20px',
                  borderStyle: 'solid',
                  boxSizing: 'border-box',
                }}
              />
            </div>
            <select
              value={selectedTeamId}
              onChange={(e) => setSelectedTeamId(Number(e.target.value))}
              className={`${STYLED_SELECT_CLASS} min-w-[160px]`}
              style={STYLED_SELECT_STYLE}
            >
              <option value={0}>All Teams</option>
              {teams.map((t) => (
                <option key={t.id} value={t.id}>{t.name}</option>
              ))}
            </select>
            <TimezoneDropdown
              value={selectedTimezone}
              onChange={handleSelectTimezone}
              options={[
                ...(user?.timezone
                  ? [{ heading: 'Your timezone', description: user.timezone, value: user.timezone }]
                  : []),
                ...(activeWorkspace?.timezone && activeWorkspace.timezone !== user?.timezone
                  ? [{
                    heading: activeWorkspace.name || 'Workspace timezone',
                    description: activeWorkspace.timezone,
                    value: activeWorkspace.timezone,
                  }]
                  : []),
              ]}
            />
          </div>

          {/* Table card */}
          <div
            className="rounded-xl bg-white shadow-[0_1px_2px_rgba(14,30,64,0.04)] overflow-hidden"
            style={{ border: '1px solid #e8eaf0' }}
          >
            <div className="overflow-x-auto">
              <div className="min-w-[720px]">
                {/* Header */}
                <div
                  className="grid grid-cols-[minmax(220px,2fr)_minmax(120px,1fr)_minmax(140px,1fr)_128px] items-center px-5 py-3 bg-surface-page text-ink-500 uppercase tracking-wider"
                  style={{
                    borderBottom: '1px solid #f1f2f5',
                    fontSize: '11px',
                    fontWeight: 600,
                    letterSpacing: '0.05em',
                  }}
                >
                  <button
                    type="button"
                    onClick={() => toggleSort('name')}
                    className={`inline-flex items-center gap-1 uppercase tracking-wider transition justify-self-start ${sortKey === 'name' ? 'text-ink-900' : 'hover:text-ink-900'}`}
                    style={{ fontSize: '11px', fontWeight: 600, letterSpacing: '0.05em' }}
                  >
                    User
                    {' '}
                    <SortIcon active={sortKey === 'name'} dir={sortDir} />
                  </button>
                  <button
                    type="button"
                    onClick={() => toggleSort('totalTime')}
                    className={`inline-flex items-center gap-1 uppercase tracking-wider transition justify-self-start ${sortKey === 'totalTime' ? 'text-ink-900' : 'hover:text-ink-900'}`}
                    style={{ fontSize: '11px', fontWeight: 600, letterSpacing: '0.05em' }}
                  >
                    Total Time
                    {' '}
                    <SortIcon active={sortKey === 'totalTime'} dir={sortDir} />
                  </button>
                  <button
                    type="button"
                    onClick={() => toggleSort('activityLevel')}
                    className={`inline-flex items-center gap-1 uppercase tracking-wider transition justify-self-start ${sortKey === 'activityLevel' ? 'text-ink-900' : 'hover:text-ink-900'}`}
                    style={{ fontSize: '11px', fontWeight: 600, letterSpacing: '0.05em' }}
                  >
                    Activity Level
                    {' '}
                    <SortIcon active={sortKey === 'activityLevel'} dir={sortDir} />
                  </button>
                  <span />
                </div>

                {/* Total row */}
                <div
                  className="grid grid-cols-[minmax(220px,2fr)_minmax(120px,1fr)_minmax(140px,1fr)_128px] items-center px-5 py-3"
                  style={{
                    backgroundColor: 'rgba(251, 251, 252, 0.5)',
                    borderBottom: '1px solid #f1f2f5',
                    fontSize: '14px',
                    lineHeight: '20px',
                  }}
                >
                  <span className="text-ink-900" style={{ fontWeight: 600 }}>Total</span>
                  <span className="text-ink-900 tabular-nums" style={{ fontWeight: 600 }}>
                    {formatSeconds(totals.totalSeconds)}
                  </span>
                  <span
                    className="tabular-nums"
                    style={{
                      color: activityColor(
                        parseFloat(String(totals.activityLabel).replace('%', '')) || 0,
                      ),
                      fontWeight: 600,
                    }}
                  >
                    {totals.activityLabel}
                  </span>
                  <span />
                </div>

                {isLoading && (
                  <div className="px-5 py-12 flex items-center justify-center">
                    <CircularProgress size={24} sx={{ color: 'inherit' }} />
                  </div>
                )}

                {!isLoading && rows.length === 0 && (
                  <div className="px-5 py-8 text-center text-sm text-ink-500">
                    No users found.
                  </div>
                )}

                {!isLoading && rows.map((r) => {
                  const fullName = `${r.firstName || ''} ${r.lastName || ''}`.trim() || (r.email || '—');
                  const c = avatarColors(r.email || r.id);
                  return (
                    <div
                      key={r.id}
                      className="grid grid-cols-[minmax(220px,2fr)_minmax(120px,1fr)_minmax(140px,1fr)_128px] items-center px-5 py-3 hover:bg-surface-page transition"
                      style={{ borderTop: '1px solid #f1f2f5', fontSize: '14px', lineHeight: '20px' }}
                    >
                      <div className="flex items-center gap-3 min-w-0">
                        <div
                          className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0"
                          style={{
                            backgroundColor: c.bg,
                            color: c.fg,
                            fontSize: '11px',
                            fontWeight: 600,
                          }}
                        >
                          {initialsFrom(r.firstName, r.lastName, r.email)}
                        </div>
                        <div className="min-w-0">
                          <Link
                            to={`/profile/${r.id}?from=/members/timesheets`}
                            className="block text-ink-900 truncate hover:text-brand-700 hover:underline"
                            style={{ fontSize: '14px', fontWeight: 500, lineHeight: '20px' }}
                          >
                            {fullName}
                          </Link>
                          <p
                            className="text-ink-500 truncate"
                            style={{ fontSize: '11px', lineHeight: '16px', marginTop: '2px' }}
                          >
                            {r.email}
                          </p>
                        </div>
                      </div>
                      <div className="text-ink-900 tabular-nums">
                        {formatSeconds(r.totalSeconds)}
                      </div>
                      <div
                        className="tabular-nums"
                        style={{
                          color: activityColor(r.activityPercent || 0),
                          fontWeight: 600,
                        }}
                      >
                        {r.activityPercent !== null ? `${r.activityPercent}%` : '--%'}
                      </div>
                      <div className="justify-self-end">
                        <Link
                          to={{
                            pathname: '/members/activity/view',
                            search: `?member=${r.id}&from=/members/timesheets`,
                            state: {
                              workspaceMember: r.member,
                              previouslySelectedDate: date[0],
                            },
                          }}
                        >
                          <button
                            type="button"
                            className="inline-flex items-center px-3 py-1.5 rounded-[8px] uppercase tracking-wider text-ink-900 bg-white border border-rule hover:border-brand-500 hover:text-brand-700 transition whitespace-nowrap"
                            style={{
                              borderStyle: 'solid',
                              fontSize: '11px',
                              fontWeight: 600,
                              letterSpacing: '0.05em',
                            }}
                          >
                            View Activity
                          </button>
                        </Link>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            {!isLoading && totalCounts > 0 && (
              <InlinePagination
                page={currentPage}
                pageSize={pageSize}
                total={totalCounts}
                onPageChange={handlePageChange}
                onPageSizeChange={handlePageSizeChange}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

Timesheets.propTypes = {};

export default Timesheets;
